import React, { useState, useMemo, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Row, Col, Card, CardBody, Table, Badge } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagination from "components/Common/Pagination"

// assets
import "../../../../assets/css/Sales/Sales.css"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import configure from "configure"
import NewPagination from "components/Common/Newpagination"

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)
  const navigate = useNavigate()

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  let paidTotal = 0
  let unpaidTotal = 0
  let Total = 0

  data.forEach(item => {
    if (item.payment_status === "paid") {
      paidTotal += parseInt(item.cost)
    } else if (item.payment_status === "unpaid") {
      unpaidTotal += parseInt(item.cost)
    }

    Total += parseInt(item.cost)
  })

  useEffect(()=>{
    setPageSize(50)
  },[])

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between align-items-center">
        <Col md={5} className="d-flex align-items-start pe-0">
          {/* counts */}
          <div className="d-flex justify-content-between w-100 text-center gap-2">
            <a
              href="#"
              className="text-success pt-2 px-2 rounded payment-count"
            >
              {/* <h4>{Total}</h4> */}
              <h4>4</h4>
              <h4>In Progress</h4>
            </a>
            <a
              href="#"
              className="text-secondary pt-2 px-2 rounded payment-count"
            >
              {/* <h4>{paidTotal}</h4> */}
              <h4>2</h4>
              <h4>On Hold</h4>
            </a>
            <a href="#" className="text-danger pt-2 px-2 rounded payment-count">
              {/* <h4>{unpaidTotal}</h4> */}
              <h4>2</h4>
              <h4>Canceled</h4>
            </a>
            <a href="#" className="text-info pt-2 px-2 rounded payment-count">
              {/* <h4>{unpaidTotal}</h4> */}
              <h4>2</h4>
              <h4>Finished</h4>
            </a>
          </div>
        </Col>
        <Col md={7} className="d-flex justify-content-end align-items-center">
          <select
            className=" form-select mb-3"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <div className=" mx-3">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline ">
              <div className="position-relative mt-2">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between mb-3">
            <div className="text-end">
              <a
                onClick={() => navigate(-1)}
                className=" btn ms-md-2 btn-red btn-label"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </a>
            </div>
          </div>
        </Col>
      </Row>
      {/* <Table
        className="table table-bordered payment-table"
        {...getTableProps()}
      >
        <thead className={`${fixedHeader ? "fix-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th key={index} {...column.getHeaderProps()}>
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td key={index} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table> */}
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedHeader && page.length >= 5 ? "fixed_edit_payment_table" : ""
            }`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      >
                        <i
                          title="info"
                          className="bx bx-info-circle ms-1 info-icon"
                        ></i>
                      </a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>


      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
      <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const Project = ({ verticalActiveTab }) => {
  const [fixButtons, setFixButtons] = useState(false)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true)
    } else {
      setFixButtons(false)
    }
  })

  const params = useParams()
  const [data, setData] = useState([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (verticalActiveTab == "5") {
      fetchFiles()
    }
  }, [verticalActiveTab])

  const fetchFiles = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("introducer_id", params.id)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/introducer_payments`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        setData(response.data.data)
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "project_id_edit",
        isInfoIcon: false,
        // Cell: cellProps => {
        //   return (
        //     <div>
        //       {moment(cellProps.row.original.created_at).format("DD-MM-YYYY")}
        //     </div>
        //   )
        // },
      },
      {
        Header: "Project",
        accessor: "projectname",
        isInfoIcon: true,
        className :"edit_projects"
      },
      {
        Header: "Start Date",
        accessor: "sdate",
        isInfoIcon: true,
        className : "edit_project_sdate"
      },
      {
        Header: "End Date",
        accessor: "edate",
        isInfoIcon: true,
        className : "edit_project_edate"
      },
      {
        Header: "Status",
        accessor: "project_status",
        isInfoIcon: true,
        className : "edit_status",
        Cell: cellProps => {
          const {project_status} = cellProps.row.original;
          const badgeClass = project_status == "In Progress" ? "bg-success custom_badge" : 
            project_status == "On Hold" ? "bg-secondary custom_badge" : 
            project_status == "Canceled" ? "bg-danger custom_badge" : 
            project_status == "Finished" ? "bg-info custom_badge" : "";        

          return (
            <Badge className={badgeClass}>
              {project_status}
            </Badge>
          )
        },
      },
    //   {
    //     Header: "Status",
    //     title: "payment_status",
    //     accessor: "status_col",
    //     className: "edit_project_status text-center",
    //     Cell: cellProps => {
    //       return (
    //         <div className="custom-select-wrapper" style={{ width: "100%" }}>
    //           <select
    //             className={`form-select custom-select`}
    //             onSelect={e => setSelectStatus(e.target.value)}
    //           >
    //             <option value="" className="">
    //               - Select -
    //             </option>
    //             <option value="notanswered" className="" selected>
    //               Not Answered
    //             </option>
    //             <option value="open" className="">
    //               Open
    //             </option>
    //             <option value="inprogress" className="">
    //               In Progress
    //             </option>
    //             <option value="answered" className="">
    //               Answered
    //             </option>
    //             <option value="onhol`d" className="">
    //               on Hold
    //             </option>
    //             <option value="Closed" className="">
    //               Closed
    //             </option>
    //           </select>
    //         </div>
    //       )
    //     },
    //   },
      {
        Header :"Action",
        accessor : "action",
        className: "edit_project_actions text-center",
        Cell: cellProps => {
            return (
                <div >
                  <Link
                    // onClick={() => handleDownload(cellProps.row.original.link)}
                    // onClick={() => downloadImage(cellProps.row.original.link)}
                    to={`${configure.appUrl}work/projects`}
                    target="_blank"
                    rel="noreferrer"
                    title="View Project"
                    className="btn action-btn btn-sm me-1 btn-outline-secondary"
                  >
                    <i className="fas fa-eye "></i>
                  </Link>
                 
                </div>
              )
        }
      }
    ],
    []
  )

  const static_data = [
    {
        id :"1",
      projectname : "crm system",
      sdate : "10/10/2024",
      edate : "31/10/2024",
      project_status : "In Progress"
    },
    {
        id :"2",
        projectname : "Eath BMS",
        sdate : "10/10/2024",
        edate : "31/10/2024",
      project_status : "On Hold"
    },
    {
        id :"3",
        projectname : "Eath BMS",
        sdate : "10/10/2024",
        edate : "31/10/2024",
      project_status : "Canceled"
    },
    {
        id :"4",
        projectname : "Eath BMS",
        sdate : "10/10/2024",
        edate : "31/10/2024",
      project_status : "Finished"
    },
  
  

  ]

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div>
        <div>
          {/* Fixed Buttons */}
          <div
            className={`flex-column fixed-buttons ${
              fixButtons ? "d-flex" : "d-none"
            }`}
          >
            <a className="btn btn-secondary  fix-btn">
              <i className="fas fa-table me-2 "></i>
              <span>Excel</span>
            </a>
            <a onClick={() => navigate(-1)} className="btn btn-red  fix-btn">
              <i className="dripicons-cross me-2 icon-center"></i>
              <span>Cancel</span>
            </a>
          </div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer columns={columns} data={static_data} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Project
